export default __webpack_public_path__ + "a76e154b45b706ed21506ec8b8ad650c.jpg";